export default "__VITE_ASSET__CJgu26G7__"